export const INIT_STATISTIC_STATE = {};

export const statisticDashboardReducer = (state, action) => {
  const { type = "" } = action;
  switch (type) {
    default:
      return state;
  }
};
